<template>
  <div class="debug" v-if="this.user.config.parameters.debug === 'true'">
    <h2>Debug:</h2>

    <ul class="debug__list debug__list--main">
      <li class="debug__item debug__item--main"><button class="debug__button debug__button--main" @click="toggle('User')">User inputs</button></li>
      <li class="debug__item debug__item--main"><button class="debug__button debug__button--main" @click="toggle('Data')">Data</button></li>
    </ul>
    <ul class="debug__list">
      <li class="debug__item"><button class="debug__button" @click="toggle('Token')">Token</button></li>
      <li class="debug__item"><button class="debug__button" @click="toggle('TraceID')">TraceID</button></li>
      <li class="debug__item"><button class="debug__button" @click="toggle('Config')">Config</button></li>
    </ul>
    <ul class="debug__list" v-if="showUser">
      <li class="debug__item"><button class="debug__button" @click="toggle('Car')">Car</button></li>
      <li class="debug__item"><button class="debug__button" @click="toggle('Department')">Department</button></li>
      <li class="debug__item"><button class="debug__button" @click="toggle('Service')">Services</button></li>
      <li class="debug__item"><button class="debug__button" @click="toggle('DateTime')">DateTime</button></li>
      <li class="debug__item"><button class="debug__button" @click="toggle('Info')">Info</button></li>
    </ul>
    <ul class="debug__list" v-if="showData">
      <li class="debug__item"><button class="debug__button" @click="toggle('Departments')">Departments</button></li>
      <li class="debug__item"><button class="debug__button" @click="toggle('Options')">Options</button></li>
    </ul>

    <div :class="['debug__container', { 'debug__container--is-open': showToken }]">
      <p class="debug__description"><strong>Token</strong> {{ user.token }}</p>
    </div>
    <div :class="['debug__container', { 'debug__container--is-open': showTraceID }]">
      <p class="debug__description"><strong>TraceID (user guid)</strong> {{ user.guid }}</p>
    </div>
    <div :class="['debug__container', { 'debug__container--is-open': showConfig }]">
      <p class="debug__description"><strong>Config</strong></p>
      <p class="debug__description">{{ user.config }}</p>
    </div>

    <hr
      class="debug__line debug__line--user"
      v-if="showUser && showingInitial && (showUserCar || showUserDepartment || showUserService || showUserDateTime || showUserInfo)"
    />
    <div v-if="showUser" :class="['debug__container', { 'debug__container--is-open': showUserCar }]">
      <p class="debug__description"><strong>Car</strong></p>
      <p class="debug__description">{{ user.car }}</p>
    </div>
    <div v-if="showUser" :class="['debug__container', { 'debug__container--is-open': showUserDepartment }]">
      <p class="debug__description"><strong>Department</strong></p>
      <p class="debug__description">{{ user.department }}</p>
    </div>
    <div v-if="showUser" :class="['debug__container', { 'debug__container--is-open': showUserService }]">
      <p class="debug__description"><strong>Selected services (jobcodes)</strong></p>
      <p class="debug__description">{{ user.selectedservices.map(selectedservice => selectedservice.jobcode) }}</p>
    </div>
    <div v-if="showUser" :class="['debug__container', { 'debug__container--is-open': showUserDateTime }]">
      <p class="debug__description"><strong>DateTime</strong></p>
      <p class="debug__description">{{ user.datetime }}</p>
    </div>
    <div v-if="showUser" :class="['debug__container', { 'debug__container--is-open': showUserInfo }]">
      <p class="debug__description"><strong>Info</strong></p>
      <p class="debug__description">{{ user.info }}</p>
    </div>

    <hr class="debug__line debug__line--data" v-if="showData && (showingInitial || showingUser) && (showDataDepartments || showDataOptions)" />
    <div v-if="showData" :class="['debug__container', { 'debug__container--is-open': showDataDepartments }]">
      <p class="debug__description"><strong>Departments List</strong></p>
      <p class="debug__description">{{ user.lists.departments }}</p>
    </div>
    <div v-if="showData" :class="['debug__container', { 'debug__container--is-open': showDataOptions }]">
      <p class="debug__description"><strong>Options List</strong></p>
      <p class="debug__description">{{ user.lists.optiondto }}</p>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('user');

export default Vue.extend({
  name: 'InfoDebug',
  computed: mapGetters(['user']),
  data() {
    return {
      showingInitial: false,
      showingUser: false,
      showingData: false,
      showUser: false,
      showData: false,
      showToken: false,
      showTraceID: false,
      showConfig: false,
      showUserCar: false,
      showUserDepartment: false,
      showUserService: false,
      showUserDateTime: false,
      showUserInfo: false,
      showDataDepartments: false,
      showDataOptions: false
    };
  },
  mounted() {
    this.showUser = window.sessionStorage.getItem('debugShowUser') === 'true' ? true : false;
    this.showData = window.sessionStorage.getItem('debugShowData') === 'true' ? true : false;
    this.showToken = window.sessionStorage.getItem('debugShowToken') === 'true' ? true : false;
    this.showTraceID = window.sessionStorage.getItem('debugShowTraceID') === 'true' ? true : false;
    this.showConfig = window.sessionStorage.getItem('debugShowConfig') === 'true' ? true : false;
    this.showUserCar = window.sessionStorage.getItem('debugShowUserCar') === 'true' ? true : false;
    this.showUserDepartment = window.sessionStorage.getItem('debugShowUserDepartment') === 'true' ? true : false;
    this.showUserService = window.sessionStorage.getItem('debugShowUserService') === 'true' ? true : false;
    this.showUserDateTime = window.sessionStorage.getItem('debugShowUserDateTime') === 'true' ? true : false;
    this.showUserInfo = window.sessionStorage.getItem('debugShowUserInfo') === 'true' ? true : false;
    this.showDataDepartments = window.sessionStorage.getItem('debugShowDataDepartments') === 'true' ? true : false;
    this.showDataOptions = window.sessionStorage.getItem('debugShowDataOptions') === 'true' ? true : false;
  },
  methods: {
    toggle(item) {
      switch (item) {
        case 'User':
          this.showUser = this.showUser ? false : true;
          window.sessionStorage.setItem('debugShowUser', this.showUser.toString());
          break;
        case 'Data':
          this.showData = this.showData ? false : true;
          window.sessionStorage.setItem('debugShowData', this.showData.toString());
          break;

        case 'Token':
          this.showToken = this.showToken ? false : true;
          this.showingInitial = this.showToken || this.showTraceID || this.showConfig;
          window.sessionStorage.setItem('debugShowToken', this.showToken.toString());
          break;
        case 'TraceID':
          this.showTraceID = this.showTraceID ? false : true;
          this.showingInitial = this.showToken || this.showTraceID || this.showConfig;
          window.sessionStorage.setItem('debugShowTraceID', this.showTraceID.toString());
          break;
        case 'Config':
          this.showConfig = this.showConfig ? false : true;
          this.showingInitial = this.showToken || this.showTraceID || this.showConfig;
          window.sessionStorage.setItem('debugShowConfig', this.showConfig.toString());
          break;

        case 'Car':
          this.showUserCar = this.showUserCar ? false : true;
          this.showingUser = this.showUserCar || this.showUserDepartment || this.showUserService || this.showUserDateTime || this.showUserInfo;
          window.sessionStorage.setItem('debugShowUserCar', this.showUserCar.toString());
          break;
        case 'Department':
          this.showUserDepartment = this.showUserDepartment ? false : true;
          this.showingUser = this.showUserCar || this.showUserDepartment || this.showUserService || this.showUserDateTime || this.showUserInfo;
          window.sessionStorage.setItem('debugShowUserDepartment', this.showUserDepartment.toString());
          break;
        case 'Service':
          this.showUserService = this.showUserService ? false : true;
          this.showingUser = this.showUserCar || this.showUserDepartment || this.showUserService || this.showUserDateTime || this.showUserInfo;
          window.sessionStorage.setItem('debugShowUserService', this.showUserService.toString());
          break;
        case 'DateTime':
          this.showUserDateTime = this.showUserDateTime ? false : true;
          this.showingUser = this.showUserCar || this.showUserDepartment || this.showUserService || this.showUserDateTime || this.showUserInfo;
          window.sessionStorage.setItem('debugShowUserDateTime', this.showUserDateTime.toString());
          break;
        case 'Info':
          this.showUserInfo = this.showUserInfo ? false : true;
          this.showingUser = this.showUserCar || this.showUserDepartment || this.showUserService || this.showUserDateTime || this.showUserInfo;
          window.sessionStorage.setItem('debugShowUserInfo', this.showUserInfo.toString());
          break;

        case 'Departments':
          this.showDataDepartments = this.showDataDepartments ? false : true;
          this.showingData = this.showDataDepartments || this.showDataOptions;
          window.sessionStorage.setItem('debugShowDataDepartments', this.showDataDepartments.toString());
          break;
        case 'Options':
          this.showDataOptions = this.showDataOptions ? false : true;
          this.showingData = this.showDataDepartments || this.showDataOptions;
          window.sessionStorage.setItem('debugShowDataOptions', this.showDataOptions.toString());
          break;

        default:
          this.showUser = false;
          this.showData = false;

          this.showToken = false;
          this.showTraceID = false;
          this.showConfig = false;

          this.showUserCar = false;
          this.showUserDepartment = false;
          this.showUserService = false;
          this.showUserDateTime = false;
          this.showUserInfo = false;

          this.showDataDepartments = false;
          this.showDataOptions = false;
          break;
      }
    }
  }
});
</script>

<style scoped lang="scss">
.debug {
  border: red 4px solid;
  margin: 2rem;
  padding: 1rem;

  &__list,
  &__item {
    display: inline-block;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__list {
    padding: 1rem;
    margin: 0 0 1rem 1rem;
    border: 1px #2e96cd solid;

    &--main {
      border-color: transparent;
    }
  }

  &__item {
    display: inline-block;
  }

  &__button {
    padding: 0.125rem 0.5rem;
    border-radius: 3px;
    border: 1px #2e96cd solid;
    background: #2e96cd;
    color: #fff;
    margin: 0 0.5rem 0 0;

    &--main {
      border-color: transparent;
      background: #5accd9;
    }
  }

  &__line {
    border: 0;
    height: 2px;
    background: red;
    margin: 2rem 0;
  }

  &__title,
  &__description {
    margin: 0;
    padding: 0;
    line-height: 1.5rem;

    strong {
      font-weight: 700;
    }
  }
  &__title {
    cursor: pointer;
  }
  &__container {
    margin: 0;
    height: 0px;
    overflow: hidden;

    &--is-open {
      margin: 0.5rem 0;
      height: auto;
      overflow: inherit;
    }
  }
}
</style>

<i18n src="../localization/texts.json"></i18n>
